import { slotsIntlIds } from './slots.ids';

export const slotsLangPtBr = {
  [slotsIntlIds.seo.pages.slotsList.title]: 'Lista de Vagas',
  [slotsIntlIds.seo.pages.slotsList.description]:
    'Aplicação web para gerenciamento de Riders e Entregas de última milha',
  [slotsIntlIds.seo.pages.slotsByHubList.title]: 'Vagas em: {hubAlias}',
  [slotsIntlIds.seo.pages.slotsByHubList.description]:
    'Aplicação web para gerenciamento de Riders e Entregas de última milha',

  [slotsIntlIds.slotsList.header.title]: `Vagas em: {hubsCount, plural,
    =0 {# Hubs}
    one {{hubAlias}}
    other {# Hubs}
  }`,
  [slotsIntlIds.slotsList.header.createSlotsButton.label]: 'Criar vagas',
  [slotsIntlIds.slotsList.header.divulgateSlotsButton.label]: 'Divulgar vagas',

  [slotsIntlIds.slotsList.table.cell.header.hubAlias]: 'Hub',
  [slotsIntlIds.slotsList.table.cell.header.totalSlots]: 'Total de vagas',
  [slotsIntlIds.slotsList.table.cell.header.bookedSlots]: 'Vagas atribuídas',
  [slotsIntlIds.slotsList.table.cell.header.availableSlots]:
    'Vagas não atribuídas',
  [slotsIntlIds.slotsList.table.cell.header.shifts]: 'Todos os turnos',
  [slotsIntlIds.slotsList.table.cell.header.dates]: 'Todas as datas',

  [slotsIntlIds.slotsList.table.cell.body.totalSlots]: `{totalSlots, plural,
    =0 {# vagas}
    one {# vaga}
    other {# vagas}
  }`,
  [slotsIntlIds.slotsList.table.cell.body.bookedSlots]: `{bookedSlots, plural,
    =0 {# vagas atribuídas}
    one {# vaga atribuída}
    other {# vagas atribuídas}
  }`,
  [slotsIntlIds.slotsList.table.cell.body.availableSlots
    .total]: `{availableSlots, plural,
    =0 {# vagas não atribuídas}
    one {# vaga não atribuída}
    other {# vagas não atribuídas}
  }`,
  [slotsIntlIds.slotsList.table.cell.body.availableSlots
    .byStatus]: `{publishedSlots, plural,
    =0 {# divulgadas}
    one {# divulgada}
    other {# divulgadas}
  }, {notPublishedSlots, plural,
    =0 {# não divulgadas}
    one {# não divulgada}
    other {# não divulgadas}
  }`,
  [slotsIntlIds.slotsList.table.cell.body.shifts]: `{shifts, plural,
    =0 {# turnos}
    one {# turno}
    other {# turnos diferentes}
  }`,
  [slotsIntlIds.slotsList.table.cell.body.dates]: `{dates, plural,
    =0 {# datas}
    one {# data}
    other {# datas diferentes}
  }`,

  [slotsIntlIds.slotsByHubList.header.title]: `Vagas {status, select,
    assigned {atribuídas}
    not_assigned {não atribuídas}
    other {}
  } em: {hubAlias}`,
  [slotsIntlIds.slotsByHubList.header.breadcrumb.allSlots]:
    'Vagas de todos os Hubs',
  [slotsIntlIds.slotsByHubList.header.breadcrumb.slotsFromHub]:
    'Vagas de {hubAlias}',

  [slotsIntlIds.slotsByHubList.searchInput.type]: `{inputType, select,
    riderId {Rider ID}
    shiftName {Turno}
    other {}
  }`,
  [slotsIntlIds.slotsByHubList.searchInput.label]: 'Buscar vagas',
  [slotsIntlIds.slotsByHubList.searchInput
    .placeholder]: `Busque {inputType, select,
    riderId {por Rider ID}
    shiftName {pelo nome do turno}
    other {}
  }`,

  [slotsIntlIds.slotsByHubList.assignedSlotsTab.label]: 'Atribuídas',
  [slotsIntlIds.slotsByHubList.hubShiftsTab.label]: 'Não atribuídas',

  [slotsIntlIds.slotsByHubList.searchSlotsButton.label]: 'Buscar vagas',

  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.date]: 'Data',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.shift]:
    'Turno atribuído',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.rider]:
    'Pessoa Rider atribuída',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.assignedAt]:
    'Atribuída em',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.originOfAssign]:
    'Origem da atribuição',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.header.cancelSlot]:
    'Cancelar',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.body.shift]:
    '{startTime} às {endTime}',
  [slotsIntlIds.assignedSlotsByHubList.table.cell.body
    .rider]: `ID {riderId}, {medal, select,
    gold {Ouro}
    silver {Prata}
    bronze {Bronze}
    other {}
  }, {modality, select,
    bicycle {Bike}
    motorcycle {Moto}
    other {}
  }`,

  [slotsIntlIds.slotOriginAssignmentTag.assignedByRaioWeb.label]:
    'Atribuído pelo Raio Web',
  [slotsIntlIds.slotOriginAssignmentTag.assignedByRaioApp.label]:
    'Atribuído pelo Raio App',

  [slotsIntlIds.createSlots.drawer.title]: 'Criar vagas',
  [slotsIntlIds.createSlots.drawer.closeDrawerButton.label]: 'Fechar drawer',

  [slotsIntlIds.createSlots.drawer.content.tabs.importSlots.label]:
    'Importar vagas',
  [slotsIntlIds.createSlots.drawer.content.tabs.createUnitarySlot.label]:
    'Criar uma vaga',

  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.title]:
    'Importar vagas',
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots
    .description]: `Faça o upload da planilha .csv preenchida com as vagas que deseja criar. Os campos data, hub, turno e quantidade de vagas são obrigatórios, então planilhas com outras colunas não serão aceitas.\nConsulte os nomes dos turnos disponíveis <link>aqui</link> para preencher a planilha e, se precisar, crie um novo turno antes de criar as vagas.`,
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.footer
    .cancelImportSlotsButton.label]: 'Cancelar',
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.footer
    .confirmImportSlotsButton.label]: 'Importar vagas',

  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots
    .success.title]: 'Vagas criadas e disponíveis para a divulgação!',
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots
    .success.description]:
    'Agora basta importar as regras de divulgação para que as pessoas Riders possam reservá-las',
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots
    .error.title]: 'Erro ao criar vagas para divulgação!',
  [slotsIntlIds.createSlots.drawer.content.tabPanels.importSlots.onImportSlots
    .error.description]:
    'Houve um problema ao criar as vagas. Verifique os dados importados e tente novamente',

  [slotsIntlIds.divulgateSlots.drawer.title]: 'Divulgar vagas',
  [slotsIntlIds.divulgateSlots.drawer.closeDrawerButton.label]: 'Fechar drawer',

  [slotsIntlIds.divulgateSlots.drawer.content.tabs.importDivulgationRules
    .label]: 'Importar regras de divulgação',
  [slotsIntlIds.divulgateSlots.drawer.content.tabs.divulgateSlots.label]:
    'Divulgar vagas',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .title]: 'Importar as regras de divulgação',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .description]: `Faça o upload da planilha .csv preenchida com as regras de divulgação que deseja divulgar. Os campos data, hub, turno, modal, medalha e quantidade de vagas são obrigatórios, então planilhas com outras colunas não serão aceitas.
    \nConsulte as vagas criadas <link>aqui</link> para preencher a planilha e, se precisar, crie novas vagas e adicione-as na planilha antes de importá-la.`,
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .footer.cancelImportDivulgationRulesButton.label]: 'Cancelar',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .footer.confirmImportDivulgationRulesButton.label]: 'Importar regras',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .onImportDivulgationRules.success.title]:
    'Regras de divulgação criadas e disponíveis para a divulgação!',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .onImportDivulgationRules.success.description]:
    'Agora basta divulgá-las para que as pessoas Riders possam reservá-las',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .onImportDivulgationRules.error.title]:
    'Erro ao criar regras de divulgação!',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.importDivulgationRules
    .onImportDivulgationRules.error.description]:
    'Houve um problema ao criar as regras de divulgação. Verifique os dados importados e tente novamente',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.title]:
    'Divulgar vagas',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .description]:
    'Confira as regras de divulgação vigentes antes de confirmar o disparo das vagas para as pessoas Riders e, se precisar mudá-las, importe uma nova planilha com as vagas e regras de divulgação que deseja.',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesStatus.noRulesImported.label]:
    'Não há regras de divulgação criadas',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesStatus.rulesBeingImported.label]:
    'Aguarde! Regras de divulgação sendo atualizadas',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesStatus.lastRulesImportedAt.label]:
    'Último upload realizado em {date} às {time}',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.title]: 'Regras de divulgação',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.slotsDates.label]: 'Datas das vagas',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.slotsDates.value]: 'de {month}',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalDates.label]: 'Datas totais',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalDates.value]: `{totalDates, plural,
      =0 {# dias}
      one {# dia}
      other {# dias diferentes}
    }`,
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalSlots.label]: 'Vagas totais',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalSlots.value]: `{totalSlots, plural,
      =0 {# vagas}
      one {# vaga}
      other {# vagas}
    }`,
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalHubs.label]: 'Hubs totais',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.totalHubs.value]: `{totalHubs, plural,
      =0 {# hubs}
      one {# hub}
      other {# hubs}
    }`,
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.shifts.label]: 'Turnos',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.modalities.label]: 'Modais',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .divulgationRulesSummary.medals.label]: 'Medalhas',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.footer
    .cancelDivulgateSlotsButton.label]: 'Cancelar',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots.footer
    .confirmDivulgateSlotsButton.label]: 'Divulgar vagas',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .confirmDivulgatePlanningModal.title]: 'Confirmar a divulgação das vagas?',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .confirmDivulgatePlanningModal.description]:
    'Ao confirmar, as vagas serão divulgadas e disponibilizadas para reserva. As pessoas Riders do segmento serão notificadas.\nAconselhamos que revise antes de confirmar.',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .confirmDivulgatePlanningModal.confirmAndDivulgateButton.label]:
    'Confirmar e divulgar',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .confirmDivulgatePlanningModal.cancelButton.label]: 'Cancelar',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .onDivulgatePlanning.success.title]:
    'Divulgação de vagas realizada com sucesso!',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .onDivulgatePlanning.success.description]:
    'Agora basta aguardar as pessoas Riders reservarem',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .onDivulgatePlanning.error.title]: 'Erro ao divulgar vagas!',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .onDivulgatePlanning.error.description]: 'Por favor, tente novamente',

  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .emptyDivulgationPlanning.title]:
    'O que acontece ao divulgar uma planilha zerada?',
  [slotsIntlIds.divulgateSlots.drawer.content.tabPanels.divulgateSlots
    .emptyDivulgationPlanning.description]:
    'Todas as divulgações de vagas dos hubs serão canceladas. Para retomá-las, envie uma nova planilha preenchida com as vagas a serem divulgadas.',

  [slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.title]:
    'Confirma a importação da planilha?',
  [slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.description]:
    'A planilha será importada e processada. Após a validação, os dados serão utilizados para criar os itens correspondentes.\nEsta ação não poderá ser desfeita.',
  [slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.confirmAndImportButton
    .label]: 'Confirmar e importar',
  [slotsIntlIds.confirmImportSlotsOrDivulgationRulesModal.cancelButton.label]:
    'Cancelar',

  [slotsIntlIds.cancelImportOrDivulgateSlotsModal.title]:
    'Tem certeza de que deseja sair?',
  [slotsIntlIds.cancelImportOrDivulgateSlotsModal.description]:
    'Suas alterações não foram salvas e você precisará repetí-las desde o início.',
  [slotsIntlIds.cancelImportOrDivulgateSlotsModal.stayAndContinueButton.label]:
    'Ficar e continuar',
  [slotsIntlIds.cancelImportOrDivulgateSlotsModal.leaveButton.label]: 'Sair',

  [slotsIntlIds.divulgationSteps.label]: 'Siga as etapas de divulgação',
  [slotsIntlIds.divulgationSteps.chevron.label]: 'Seta para a direita',
  [slotsIntlIds.divulgationSteps.createSlot.label]: 'Crie as vagas',
  [slotsIntlIds.divulgationSteps.createSlot.description]:
    'Importe uma planilha ou crie manualmente vagas sem atribuição',
  [slotsIntlIds.divulgationSteps.importRules.label]: 'Importe as regras',
  [slotsIntlIds.divulgationSteps.importRules.description]:
    'Importe uma planilha com as vagas criadas e cada regra de divulgação',
  [slotsIntlIds.divulgationSteps.divulgateSlots.label]: 'Divulgue as vagas',
  [slotsIntlIds.divulgationSteps.divulgateSlots.description]:
    'Confira as regras e confirme a divulgação para as pessoas Riders',

  [slotsIntlIds.cancelRiderBookedSlotModal.trigger.openModalButton.label]:
    'Cancelar reserva',
  [slotsIntlIds.cancelRiderBookedSlotModal.header.title]:
    'Cancelar reserva desta vaga?',
  [slotsIntlIds.cancelRiderBookedSlotModal.header.closeIconButton.label]:
    'Fechar',
  [slotsIntlIds.cancelRiderBookedSlotModal.body.description]:
    'Ao confirmar, a reserva da pessoa Rider selecionada para o <highlight>turno {shiftName} ({shiftStartsAt} às {shiftEndsAt}) no dia {slotDate}</highlight> será cancelada.\n Após o cancelamento, a vaga poderá ser reservada por outras pessoas que tenham esse Hub como preferência.',
  [slotsIntlIds.cancelRiderBookedSlotModal.footer.cancelButton.label]:
    'Cancelar',
  [slotsIntlIds.cancelRiderBookedSlotModal.footer.confirmAndCancelButton.label]:
    'Confirmar cancelamento',
  [slotsIntlIds.cancelRiderBookedSlotModal.toasts.onSuccess.title]:
    'Cancelamento da reserva realizado com sucesso!',
  [slotsIntlIds.cancelRiderBookedSlotModal.toasts.onSuccess.description]:
    'A pessoa Rider será notificada sobre a alteração',
  [slotsIntlIds.cancelRiderBookedSlotModal.toasts.onError.title]:
    'Erro ao cancelar reserva!',
  [slotsIntlIds.cancelRiderBookedSlotModal.toasts.onError.description]:
    'Por favor, tente novamente',
};
